import { BASE_PATH } from '@/constants/env';
import GiftCardsNameOverrides from '@/constants/giftCardsNameOverride';

export const urlParser = (url: string) => {
  return BASE_PATH ? `${BASE_PATH}${url}` : url;
};

export const BlobToDataURL = (file: Blob) => {
  return new Promise<string>((resolve, reject) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      //@ts-ignore
      resolve(reader.result);
    };
    reader.onerror = (e) => reject(e.toString());
    reader.readAsDataURL(file);
  });
};

export function formatGiftcardName(name: string) {
  // ET-6606 rename some gift cards names
  if (GiftCardsNameOverrides[name as keyof typeof GiftCardsNameOverrides]) {
    return GiftCardsNameOverrides[name as keyof typeof GiftCardsNameOverrides];
  }
  return name;
}
